import React, { useEffect } from 'react';
import './steps.css';

export const ARMS = [
    { key: 'control', title: 'Control', fallback: 'unmodified page' },
    { key: 'variant', title: 'B', fallback: 'variant' },
];

/** A captured screenshot thumbnail; opens the side-by-side view. */
export const ShotThumb = ({ shot, title, onOpen, className = 'epm-build__shot has-img' }) => (
    <button type="button" className={className} onClick={onOpen} title={`${title}: ${shot.label || ''} — enlarge`}>
        <img src={shot.src} alt={`${title}: ${shot.label || ''}`} loading="lazy" />
    </button>
);

/** Control and variant side by side, full height. */
export const ShotLightbox = ({ mockups, onClose }) => {
    useEffect(() => {
        const onKey = (e) => { if (e.key === 'Escape') onClose(); };
        window.addEventListener('keydown', onKey);
        return () => window.removeEventListener('keydown', onKey);
    }, [onClose]);
    return (
    <div className="epm-step-lightbox" onClick={onClose} role="dialog" aria-modal="true" aria-label="Control and variant side by side">
        <div className="epm-step-lightbox__row" onClick={(e) => e.stopPropagation()}>
            {ARMS.filter((arm) => mockups?.[arm.key]?.src).map((arm) => (
                <figure key={arm.key}>
                    <img src={mockups[arm.key].src} alt={`${arm.title}: ${mockups[arm.key].label || arm.fallback}`} />
                    <figcaption><b>{arm.title}</b> · {mockups[arm.key].label || arm.fallback}</figcaption>
                </figure>
            ))}
        </div>
        <button type="button" className="epm-step-lightbox__close" onClick={onClose}>✕ Close</button>
    </div>
    );
};
